// @ts-check

import { createSubmitListener } from "./mailSubmitListener";
import { performMinMaxValidation } from "../../../common/betragFunctions";
import { createLimitRowsListener } from "./textareaRowLimit";
import { performPatternValidation } from "./additionalValidation";

function getRemainigLettersTemplate(textarea) {
  return `Noch ${window.parseInt(textarea.getAttribute("maxlength")) - textarea.value.length} Zeichen übrig.`;
}
class MailFormular extends HTMLElement {
  static get tagName() {
    return "mail-formular";
  }

  connectedCallback() {
    this.declareElements();
    this.declareAndRegisterListeners();
    this.verbleibendeZeichen.innerText = getRemainigLettersTemplate(this.nachricht);
    this.zustellungAnToggle();
  }

  declareElements() {
    /** @type {HTMLFormElement} */
    this.form = this.querySelector("form");
    /** @type {HTMLInputElement} */
    this.absender = this.querySelector(".absender");
    /** @type {HTMLInputElement} */
    this.empfaenger = this.querySelector(".empfaenger");
    /** @type {HTMLInputElement} */
    this.email = this.querySelector(".email");
    /** @type {HTMLInputElement} */
    this.abweichenderEmpfaenger = this.querySelector(".sendenAnEmpfaenger");
    /** @type {HTMLInputElement} */
    this.betrag = this.querySelector(".betrag");
    /** @type {HTMLParagraphElement} */
    this.hinweis = this.querySelector(".hinweis");
    /** @type {HTMLButtonElement} */
    this.warenkorbButton = this.querySelector(".warenkorb-button");
    /** @type {HTMLTextAreaElement} */
    this.nachricht = this.querySelector(".nachricht");
    /** @type {HTMLSpanElement} */
    this.verbleibendeZeichen = this.querySelector(".verbleibende-zeichen");
    /** @type {import("../../karten-carousel/src/karten-carousel").KartenCarousel} */
    this.carousel = this.querySelector("karten-carousel");
  }

  declareAndRegisterListeners() {
    this.addListener(this.form, "submit", createSubmitListener(this));
    this.addListener(this.betrag, "blur", () => {
      performMinMaxValidation(this.betrag); 
    });
    this.addListener(this.nachricht, "blur", () => {
      performPatternValidation(this.nachricht); 
    });
    this.addListener(this.nachricht, "input", createLimitRowsListener(this.nachricht));
    this.addListener(this.nachricht, "input", () => {
      this.verbleibendeZeichen.innerText = getRemainigLettersTemplate(this.nachricht); 
    });
  }

  zustellungAnToggle() {
    /** @type {HTMLInputElement []} */
    const verschenkenRadios = Array.from(this.querySelectorAll(".element-input-radio"));
    verschenkenRadios.forEach((radio) => {
      this.addListener(radio, "change", (event) => {
        
        /** @type {any} */
        const { target } = event;
        const radioValue = (target).value;

        if (radioValue === "absender") {
          this.abweichenderEmpfaenger.setAttribute("abweichender-empfaenger", "false");
          this.email.removeAttribute("required");
          this.email.value = "";
        } else {
          this.email.setAttribute("required", "required");
          this.abweichenderEmpfaenger.setAttribute("abweichender-empfaenger", "true");
        }
      });
    });
  }

  /**
   * @param {HTMLElement} element
   * @param {string} type
   * @param {EventListenerOrEventListenerObject} listener
   */
  addListener(element, type, listener) {
    this.listeners = this.listeners || [];
    this.listeners.push({ listener, element, type });
    element.addEventListener(type, listener);
  }

  disconnectedCallback() {
    this.listeners.forEach(({ element, type, listener }) => {
      if (element) {
        element.removeEventListener(type, listener);
      }
    });
  }
}

if (!customElements.get(MailFormular.tagName)) {
  customElements.define(MailFormular.tagName, MailFormular);
}
